module.exports = __webpack_public_path__ + "img/elv.4442aa5e.png";